
import { sortBy } from 'lodash';
import { Component, Emit, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { OrderMethods } from '@/enums';
import UserModule from '@/store/modules/user';

@Component({
  components: {
  }
})
export default class SingleLocation extends Vue {
  @Prop({ type: Number, default: null }) id: number;
  @Prop({ type: String, default: '' }) name: string;
  @Prop({ type: String, default: '' }) slug: string;
  @Prop({ type: Number, default: '' }) distanceFromUser: number;
  @Prop({ type: String, default: '' }) phoneNumber: string;
  @Prop({ type: String, default: '' }) street: string;
  @Prop({ type: String, default: '' }) city: string;
  @Prop({ type: String, default: '' }) state: string;
  @Prop({ type: String, default: '' }) zip: string;
  @Prop({ type: Boolean, default: false }) supportsPickup: boolean;
  @Prop({ type: Boolean, default: false }) supportsDelivery: boolean;
  @Prop({ type: Boolean, default: false }) supportsCurbside: boolean;
  @Prop({ type: Boolean, default: false }) supportsTransfers: boolean;
  @Prop({ type: Boolean, default: false }) supportsGroupOrders: boolean;
  @Prop({ type: Boolean, default: false }) isEditMode: boolean;

  @InjectReactive() viewContainerRef!: HTMLElement;
  @InjectReactive('currentOrderMethod') currentOrderMethod: OrderMethods | null;
  @Getter activeRestaurant!: Restaurant;

  @Emit('info')
  info() {
    return { ...this.$props, ...this.$attrs };
  }

  @Emit('set')
  selectLocation() {
    return { ...this.$props, ...this.$attrs };
  }

  get favoriteStores() {
    return sortBy(UserModule.favoriteRestaurants, ['isDefault']).reverse();
  }

  get isFavorite() {
    return this.favoriteStores?.find((s) => s.id === this.id) || {};
  }

  get isDefault() {
    const store = UserModule.favoriteRestaurants.find((restaurant) => restaurant.id === this.id);
    return store?.isDefault || false;
  }

  get isActive() {
    return this.id === this.activeRestaurant?.id;
  }

  get supportsCurrentMethod() {
    return this[`supports${this.currentOrderMethod?.capitalize()}`];
  }

  get wrapperClasses() {
    return {
      disabled: !this.supportsCurrentMethod,
    };
  }

  get isLoggedIn() {
    return UserModule?.loggedIn || false;
  }

  async handleAddFavorite() {
    try {
      const favoriteModel = await UserModule.addFavoriteLocation({ restaurantId: this.id, isDefault: false }) as FavoriteLocationModel;
      if (favoriteModel) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { actionButtonText, ...rest } = this.$props as any;
        const addedLocation: FavoriteRestaurant = {
          ...rest,
          isDefault: favoriteModel.isDefault,
          favoriteId: favoriteModel.id
        };
        UserModule.addFavoriteLocationToCustomer(addedLocation);
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    }
  }

  async handleRemoveFavorite() {
    const favorite = UserModule.favoriteRestaurants.find((restaurant) => restaurant.id === this.id);
    if (favorite) {
      try {
        await UserModule.removeFavoriteLocation(favorite.id);
        UserModule.removeFavoriteLocationFromCustomer(favorite);
      } catch (err) {
        this.$log.error(err);
        this.$toasted.error(err.data);
      }
    }
  }

  async handleMakeDefault() {
    try {
      const favoriteModel = await UserModule.addFavoriteLocation({ restaurantId: this.id, isDefault: true }) as FavoriteLocationModel;
      if (favoriteModel) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { actionButtonText, ...rest } = this.$props as any;
        const addedLocation: FavoriteRestaurant = {
          ...rest,
          isDefault: favoriteModel.isDefault,
          favoriteId: favoriteModel.id
        };
        UserModule.addFavoriteLocationToCustomer(addedLocation);
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    }
  }
}
